import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import { api_call, console_log, copyObject, empty, get_data_value, is_null, returnMobileApp } from '../helpers/untils';
import {
  Button, TextField, Typography, Box, Checkbox, Snackbar, makeStyles,
  TableContainer, Table, TableRow, TableCell, TableHead, TableBody, IconButton
} from '@material-ui/core';

import { Select, MenuItem } from '@material-ui/core';

import { Stack } from '@mui/material';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import moment from 'moment';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';

import ConfirmDialog from '../components/ConfirmDialog';
import { APP_NAME, DEFAULT_M_SOUND, DISTANCE_UNIT_LIST, MAINT_VIDEO_ID, NOTIFICATION_SOUND_LIST } from '../config/constant';
import { sleep } from '../helpers/misc';
import SelectField from '../form/SelectField';

const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: '1px solid rgba(224, 224, 224, 1)',
      verticalAlign: 'middle',
      textAlign: 'center'
    }
  }
});

const MaintSimpleListTable = (props) => {
  const { open, setOpen, deviceId, deviceItem, setDeviceItem, onClickPL } = props
  const user = useSelector((state) => state.session.user);

  const classes = useStyles();
  const history = useHistory()
  const [pageLoading, setPageLoading] = useState(false)
  const [device, setDevice] = useState({})

  const defaultLogRow = {
    date: '',
    miles: '',
  }

  const loadPageData = async () => {
    setPageLoading(true)
    const url = `/api/maint/${deviceId}`
    const response = await api_call(url);
    if (response.ok) {
      const responseObj = await response.json();
      initDeviceFieldData(responseObj.device)
    }
    setPageLoading(false)

    if (deviceItem['maint_item_list']) {
      setItemList(deviceItem['maint_item_list']);
    }
  }
  const initDeviceFieldData = (device) => {
    setDevice(device);
    // setNotificationEmail(device.maint_notification_email)
    let deviceOdometer = device.odometer;
    if (deviceOdometer) {
      deviceOdometer = parseInt(deviceOdometer);
    } else {
      deviceOdometer = 0;
    }
    setMaintOdometer(deviceOdometer);
  }

  useEffect(() => {
    loadPageData();
  }, [deviceId]);

  const defaultPushSound = 'hood' // user?.m_sound || DEFAULT_M_SOUND;
  const defaultItem = {
    name: "",
    note: "",
    days: "",
    miles: "",
    log_list: [],
    m_sound: defaultPushSound,
    co_host: true, //true, false
    repeat: true //true, false
  }
  const defaultItemList = [defaultItem]
  const [itemList, setItemList] = useState(defaultItemList)
  const [distanceUnit, setDistanceUnit] = useState("mile");

  const showToast = (msg) => {
    setToastMessage(msg)
    setSnackbarOpen(true)
  }

  const onClickAddRow = () => {
    const item_list = [...itemList]
    const item = {
      ...defaultItem
    }
    const newLogRow = {
      ...defaultLogRow
    }
    const log_list = [newLogRow]
    item['log_list'] = log_list
    item_list.push(item)
    setItemList(item_list)
  }

  const onClickDeleteItem = (index) => {
    const item_list = [...itemList]
    item_list.splice(index, 1);
    setItemList(item_list);
  }

  const getItemField = (field_name, index, default_value) => {
    let v = default_value
    let item = itemList[index]
    if (item) {
      v = get_data_value(item, field_name, default_value)
    }
    if (field_name === "repeat") {
      if (v) {
        v = true
      } else {
        v = false
      }
    }
    return v
  }

  const onChangeItemField = (v, field_name, index) => {
    setCheckError(false)
    const itme_list = [...itemList]
    const item = itme_list[index]
    if (item) {
      if (field_name === "repeat") {
        if (v) {
          v = true
        } else {
          v = false
        }
      }
      item[field_name] = v
      itme_list[index] = item
      setItemList(itme_list)
    }
  }

  const checkItemListValidation = (item_list) => {
    return true
  }

  const onClickSave = async () => {
    await sleep(100)
    const item_list = [...itemList]
    if (item_list.length > 0) {
      const isValid = checkItemListValidation(item_list)
      if (!isValid) {
        showToast("Please fill out all necessary fields")
        return false
      }
    }
    // const maint_charge_enabled = device.maint_charge_enabled
    // if (is_null(maint_charge_enabled)) {
    //   setShowConfirmModal(true)
    // } else {
    //   submitData(null)
    // }
    submitData(null)
  }

  const onClickCancelConfirm = () => {
    setShowConfirmModal(false)
    submitData(false)
  }

  const onClickAgreeConfirm = () => {
    setShowConfirmModal(false)
    submitData(true)
  }

  const submitData = async (agreed = null) => {
    if (deviceId) {
      let url = `/api/maint-simple/${deviceId}`;
      const payload = {
        maint_odometer: maintOdometer,
        // maint_notification_email: notificationEmail,
        // maint_charge_enabled: agreed,
        maint_item_list: itemList
      }
      const response = await api_call(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        let responseObj = await response.json();
        showToast("Saved successfully")
        setTimeout(() => {
          setOpen(false)
        }, 1500)
      } else {
        alert("Error encounted")
      }
    }
    else {
      const newItem = { ...deviceItem, maint_item_list: itemList };
      console.log(`newItem`, newItem);
      setDeviceItem(newItem);
      setOpen(false)
    }
  }

  const getDistanceUnitName = () => {
    const unitItem = DISTANCE_UNIT_LIST.find((x) => x.id === deviceItem.distance_unit);
    const unitName = unitItem?.name ?? "Miles";
    return unitName;
  }
  const [maintOdometer, setMaintOdometer] = useState(0)

  const [checkError, setCheckError] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  return (
    <React.Fragment>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={snackbarOpen}
          onClose={() => { setSnackbarOpen(false) }}
          autoHideDuration={1500}
          message={toastMessage}
        />

        <Box sx={{ mb: 2 }}>
          <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={2} style={{ width: '100%' }}>
            <Button type="button" color="primary" variant="contained" onClick={() => onClickAddRow()}>
              Add
            </Button>
            <Box sx={{ width: '200px' }}>
              <TextField
                className='odometer'
                fullWidth
                label={`Odometer`}
                margin="normal"
                value={maintOdometer}
                onChange={(event) => setMaintOdometer(event.target.value)}
                placeholder={``}
                variant="filled"
                inputProps={{
                  type: 'number'
                }}
              />
            </Box>
          </Stack>
        </Box>
        <Box sx={{ mb: 2 }}>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2}>Name</TableCell>
                  <TableCell colSpan={2}>Every</TableCell>
                  <TableCell rowSpan={2}>Push Notification</TableCell>
                  <TableCell rowSpan={2}>Co-Host</TableCell>
                  <TableCell rowSpan={2} style={{ width: '100px' }}>Action</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Days</TableCell>
                  <TableCell>
                    {getDistanceUnitName()}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  (itemList.length > 0) ? (
                    <>
                      {
                        itemList.map((item, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell>
                                <Box sx={{ minWidth: '200px', width: '100%', display: 'inline-block' }}>
                                  <TextField
                                    error={checkError && getItemField("name", index) === ""}
                                    className='name'
                                    fullWidth
                                    // margin="normal"
                                    value={getItemField("name", index)}
                                    onChange={(event) => onChangeItemField(event.target.value, "name", index)}
                                    placeholder={`Oil change`}
                                    variant="filled"
                                  />
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ minWidth: '100px', width: '100%', display: 'inline-block' }}>
                                  <TextField
                                    className='days'
                                    fullWidth
                                    //margin="normal"
                                    value={getItemField("days", index)}
                                    onChange={(event) => onChangeItemField(event.target.value, "days", index)}
                                    placeholder={``}
                                    variant="filled"
                                    inputProps={{
                                      type: 'number'
                                    }}
                                  />
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ minWidth: '100px', width: '100%', display: 'inline-block' }}>
                                  <TextField
                                    className='miles'
                                    fullWidth
                                    //margin="normal"
                                    value={getItemField("miles", index)}
                                    onChange={(event) => onChangeItemField(event.target.value, "miles", index)}
                                    placeholder={``}
                                    variant="filled"
                                    inputProps={{
                                      type: 'number'
                                    }}
                                  />
                                </Box>
                              </TableCell>

                              <TableCell>
                                <Box sx={{ display: 'inline-block' }}>
                                  <Select
                                    value={getItemField("m_sound", index)}
                                    onChange={(event) => onChangeItemField(event.target.value, "m_sound", index)}
                                    variant="filled"
                                  >
                                    {
                                      NOTIFICATION_SOUND_LIST.map((n_item) => {
                                        return (
                                          <MenuItem key={n_item.value} value={n_item.value}>{n_item.name}</MenuItem>
                                        )
                                      })
                                    }
                                  </Select>
                                </Box>
                              </TableCell>

                              <TableCell>
                                <Box sx={{ display: 'inline-block' }}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={getItemField("co_host", index)}
                                        onChange={(event) => onChangeItemField(event.target.checked, "co_host", index)}
                                      />
                                    }
                                    label=""
                                    style={{ marginRight: 0, marginLeft: 0 }}
                                  />
                                </Box>
                              </TableCell>

                              <TableCell>
                                <Stack direction={`row`} justifyContent={`center`} alignItems={`center`} spacing={1}>
                                  <IconButton title="Delete" color="primary" onClick={() => onClickDeleteItem(index)}>
                                    <CloseIcon />
                                  </IconButton>
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      }
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell colSpan={4} align={`center`}>
                          {(pageLoading) ? 'Loading...' : 'No record found'}
                        </TableCell>
                      </TableRow>
                    </>
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <Box sx={{ mb: 1 }}>
          <Stack direction={`column`} justifyContent={`flex-start`} alignItems={`flex-start`} spacing={1}>
            <Typography variant="body2">
              Notification Email
            </Typography>
            <TextField
              fullWidth
              margin="normal"
              value={notificationEmail}
              onChange={(event) => setNotificationEmail(event.target.value)}
              placeholder={`Enter emails with comma separated`}
              variant="filled"
            />
          </Stack>
        </Box> */}
        <Box sx={{ mb: 1 }}>
          <Stack direction={`row`} justifyContent={`flex-end`} alignItems={`center`} spacing={1}>
            <Button type="button" color="primary" variant="contained" onClick={() => onClickSave()}>
              Save
            </Button>
            {/* <Button type="button" color="primary" variant="outlined" onClick={() => setOpen(false)}>
                    Close
                </Button> */}
          </Stack>
        </Box>

        <>
          <ConfirmDialog
            open={showConfirmModal}
            setOpen={setShowConfirmModal}
            title={APP_NAME}
            content={`The cost for this service is $1 per month per car.`}
            textYes={`Agree`}
            textNo={`Cancel`}
            onClickYes={() => onClickAgreeConfirm()}
            onClickNo={() => onClickCancelConfirm()}
          />
        </>
      </div>
    </React.Fragment>
  )
}

export default MaintSimpleListTable;